// Legacy stub. Old helper module; only formatDateTime is still
// imported (by ChatWindow.tsx) and lives here as a generic util.

export function formatDateTime(ms?: number): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleString('zh-CN');
}

export function formatDate(ms?: number): string {
  if (!ms) return '—';
  return new Date(ms).toLocaleDateString('zh-CN');
}
